<template>
    <rkm-overlay>
        <rkm-layout-body title="Agendar transporte">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="isPermissaoCadastro"
                    @click.stop="$refs.ModalPacienteCadastroSimplificado.open(id)"
                >
                    Editar paciente
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.preAgendar()"
                    color="info"
                >
                    Viagem pré agendada
                </rkm-button>

                <rkm-button
                    v-if="hasPermissaoAtualizacaoCadastroPaciente"
                    @click="handleBuscarDadosPacienteIntegracaoCns"
                    color="info"
                >
                    Buscar dados do paciente no CADSUS
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @save="handleSave"
                    @handleExitPaciente="handleExitPaciente"
                    @handleAtualizaPaciente="handleAtualizaPaciente"
                    @permissao="handlePermissao"
                    ref="Form"
                    @loaded="loaded"
                />
            </rkm-layout-content>

            <ModalIntegracaoCns
                @update="handleIntegracaoCnsUpdate"
                ref="ModalIntegracaoCns"
            />
        </rkm-layout-body>

        <ModalPacienteCadastroSimplificado
            ref="ModalPacienteCadastroSimplificado"
            @save="reloadTransporteAgendar"
        />
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/transporte-paciente/agendar/Form'
import ModalPacienteCadastroSimplificado from '@/components/cadastro/paciente/components/cadastro-simplificado/Modal'
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

// Mixins.
import {unmask} from '@/mixins'

// Vuex.
import { mapActions } from 'vuex';

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'

export default {
    components: {
        Form,
        ModalPacienteCadastroSimplificado,
        ModalIntegracaoCns,
    },
    computed: {
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
    },
    created() {
        this.setShowExitFormConfirmation()
    },
    data: () => ({
        additionals: null,
        isPermissaoCadastro: null,
        enums: {
            classificacao,
        },
        form: null,
    }),
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation'
        ]),
        loaded(value) {
            this.additionals = value.additionals
            this.form = value.form

            if (this.additionals.enderecoDesatualizadoBloqueado) {

                this.unsetShowExitFormConfirmation()

                this.showAlert(
                    'O endereço do paciente ainda não foi atualizado pela Base Nacional. Atualize o cadastro para continuar.',
                    'Atenção'
                )

                this.handleExit()
            }
        },
        handleExit() {
            this.$router.push({ name: 'transporte-paciente-agendar-list' })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
        handleExitPaciente() {

            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
        handleAtualizaPaciente() {

            this.unsetShowExitFormConfirmation()
            this.$router.push({ name: 'cadastro-paciente-edit', params: { id: this.id } })
        },
        reloadTransporteAgendar() {
            this.$router.go(0);
        },
        handlePermissao(item) {

            if (item.isPermissaoCadastro) {
                this.isPermissaoCadastro = true;
            } else {

                const classificacoes = item.classificacoes;
                const classificacaoId = item.paciente.classificacaoId;

                const isClassificacaoPresent = (classificacaoId) => {
                    return classificacoes.some(classificacao => classificacao.id === classificacaoId);
                };

                switch (classificacaoId) {
                    case this.enums.classificacao.MUNICIPE:
                    case this.enums.classificacao.PROVISORIO:
                    case this.enums.classificacao.OUTRO_MUNICIPIO:
                        this.isPermissaoCadastro = isClassificacaoPresent(classificacaoId);
                        break;
                    default:
                        this.isPermissaoCadastro = false;
                }
            }
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.form.paciente.cidadaoId,
                nome: this.form.paciente.nome,
                dataNascimento: this.form.paciente.dataNascimento,
                nomeMae: this.form.paciente.nomeMae,
                cns: this.form.paciente.cns ? this.unMaskCns(this.form.paciente.cns) : null,
                cpf: this.form.paciente.cpf ? this.unMaskCpf(this.form.paciente.cpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate(item) {
            Object.assign(this.form.paciente, {
                ...item,
                racaCorId: item.racaCor.id,
            })
        },
    },
    mixins: [unmask],
    props: {
        id: { type: Number, default: null }
    },
}
</script>